<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" @change="cambiarDatos($event)" class="form-control">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} una institución</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} las instituciones</option>
        <option v-for="Institucion in Instituciones" :key="Institucion.InstitucionId" :value="Institucion.InstitucionId">{{Institucion.Nombre}}</option>        
      </select>      
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    data() {
      return {
        enumeraciones,
        Instituciones: [],
        idDelModelo:null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput:String,
      valorDefinido: Number,
      parametros: Object
    },
    mounted(){     
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

        const params = {
          llave: this.idDelInput,
          valor: this.idDelModelo
        }
        this.$store.dispatch("A_SICUS_Catalogos_Establecer055Institucion", params);
    },
    created(){
      this.cargaCatalogoDeInstituciones();
    },
    methods:{
      cargaCatalogoDeInstituciones(){
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba

        axios.post(api.conexion + api.SICUS.catalogos.C055Instituciones, 
          this.parametros,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.error(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              } else {              
                this.Instituciones = respuesta.data.Instituciones;
              }
          })
          .catch(excepcion => 
          {
            console.error(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          });            
      },      
      cambiarDatos(evento){
        this.idDelModelo = evento.target.value;
        const params = {
          llave: this.idDelInput,
          valor: evento.target.value
        }

        this.$store.dispatch("A_SICUS_Catalogos_Establecer055Institucion", params);
        this.$emit("valorParaElPadre",evento);           
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SICUS/Comun/Catalogos/055Instituciones.vue